import { render } from "./HelpMore.vue?vue&type=template&id=6eb210f8"
import script from "./HelpMore.vue?vue&type=script&lang=js"
export * from "./HelpMore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/help/HelpMore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6eb210f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6eb210f8', __exports__)) {
    api.reload('6eb210f8', __exports__)
  }
  
  module.hot.accept("./HelpMore.vue?vue&type=template&id=6eb210f8", () => {
    api.rerender('6eb210f8', render)
  })

}


export default __exports__